export default __webpack_public_path__ + "static/media/bronze_60F_x264.c46f9699.mp4";